"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingAddress = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _CountrySelect = require("./CountrySelect");
var _ZipCode = require("./ZipCode");
var _countryCodes = require("../../utils/countryCodes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BillingAddress = _ref => {
  let {
    mt = 2,
    countryCode,
    onCountryCodeChange,
    zipCode,
    onZipCodeChange,
    zipCodeValid: isZipCodeValid,
    setZipCodeValid,
    disabled: isDisabled
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: mt
  }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_CountrySelect.CountrySelect, {
    value: countryCode,
    onChange: onCountryCodeChange,
    disabled: isDisabled
  })), _countryCodes.requiredZipCountryCodes.includes(countryCode) && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_ZipCode.ZipCode, {
    required: true,
    countryCode: countryCode,
    value: zipCode,
    onChange: onZipCodeChange,
    disabled: isDisabled,
    valid: isZipCodeValid,
    setValid: setZipCodeValid
  })));
};
exports.BillingAddress = BillingAddress;